<template>
  <div id="video-detail">
    <!-- <video :src="liveInfo.url" style="width: 100%" controls></video> -->
    <div
      v-if="loaded"
      class="vuealiplayer"
      :style="{ width: `${innerWidth}px`, height: `${innerHeight}px` }"
    >
    
      <div
        class="px-video-container"
        id="video_player"
        :height="innerHeight"
        :width="innerWidth"
      >
        <div class="px-video-img-captions-container">
          <div class="px-video-captions hide" aria-hidden="true"></div>
          <video :height="innerHeight" :width="innerWidth" controls>
            <source :src="liveInfo.url" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
    <div
      v-if="liveInfo.showLeftStationLogo"
      style="position: fixed; top: 0px; left: 0px; z-index: 22"
    >
      <img src="@/assets/station_logoLeft.png" alt="logo" style="width: 100%" />
    </div>
    <div
      v-if="liveInfo.showRightStationLogo"
      style="position: fixed; top: 0px; right: 0px; z-index: 22"
    >
      <img
        src="@/assets/station_logoRight.png"
        alt="logo"
        style="width: 100%"
      />
    </div>
    <div class="categoryR">
      <div
        :class="{
          categoryRContent: true,
          categoryRActive: currentRecommend == item.index,
        }"
        v-for="(item, key) in recommendC"
        :key="key"
        @click="changeCurrent(item.index)"
      >
        {{ item.value }}
      </div>
    </div>
    <div
      v-if="currentRecommend == 'video'"
      :style="{
        height: `${contentHeight}rem`,
        'overflow-y': 'scroll',
        marginBottom: '3.5rem',
      }"
    >
      <div style="padding: 5px 10px 10px">
        <div>
          <div style="display: flex; align-items: center; position: relative">
            <div @click="goToAccount">
              <el-avatar :size="50" :src="authorInfo.avatar"></el-avatar>
            </div>
            <div style="font-size: 14px; margin-left: 5px">
              <div>
                {{ liveInfo.authorName }}

                <span
                  :style="{
                    backgroundColor:
                      authorInfo.tag == '官方'
                        ? 'rgb(0, 153, 255)'
                        : 'rgb(0, 204, 0)',
                    color: '#FFF',
                    padding: '3px 6px',
                    borderRadius: '5px',
                  }"
                  >{{ authorInfo.tag }}</span
                >
              </div>
              <div style="color: #999999" v-if="!liveInfo.showFansNumber">
                粉丝:{{ authorInfo.fanNumber }}
              </div>
            </div>
            <div class="fouse" @click="download">+关注</div>
          </div>
          <div style="display: flex; align-items: center"></div>
        </div>
        <div class="title">
          {{ liveInfo.title }}
          <i
            v-if="isShow"
            @click="showDescri(false)"
            class="el-icon-caret-top hidden"
          ></i>
          <i
            v-if="!isShow"
            @click="showDescri(true)"
            class="el-icon-caret-bottom hidden"
          ></i>
        </div>
        <div>
          <span>{{ liveInfo.categoryName }}</span>
          <span v-if="!liveInfo.showPlayNumber"
            >{{ liveInfo.playNumber | formatReadNumber }}观看</span
          >
          <span
            >{{ moment(liveInfo.createTime).format("YYYY-MM-DD") }}发布</span
          >
        </div>
      </div>
      <div style="padding: 0px 10px 10px" v-if="isShow">
        <div style="font-size: 0.9rem">{{ liveInfo.description }}</div>
      </div>
      <div style="display: flex; text-align: center" class="description">
        <div
          style="display: inline-block; padding: 0px 15px; text-align: center"
        >
          <div style="font-size: 30px; color: green" @click="download">
            <svg-icon icon-class="u1857" />
          </div>
          <div>
            {{ liveInfo.likeNumber }}
          </div>
        </div>
        <div
          style="display: inline-block; padding: 0px 15px; text-align: center"
        >
          <div style="font-size: 30px; color: green" @click="download">
            <svg-icon icon-class="u1858" />
          </div>
          <div>
            {{ liveInfo.collectionNumber }}
          </div>
        </div>
        <div
          style="display: inline-block; padding: 0px 15px; text-align: center"
        >
          <div style="font-size: 30px; color: green" @click="downloadShare">
            <svg-icon icon-class="u1861" />
          </div>
          <div>
            {{ liveInfo.shareNumber }}
          </div>
        </div>
        <div
          style="display: inline-block; padding: 0px 15px; text-align: center"
        >
          <div style="font-size: 30px; color: green" @click="download">
            <svg-icon icon-class="u1859" />
          </div>
          <div>缓存</div>
        </div>
        <div
          style="display: inline-block; padding: 0px 15px; text-align: center"
        >
          <div style="font-size: 30px; color: green" @click="download">
            <svg-icon icon-class="u1860" />
          </div>
          <div>举报</div>
        </div>
      </div>
      <div class="otherVideo" v-if="liveInfo.videoSeries.length > 1">
        <div class="otherTitle">
          <span class="title">列表</span>
          <span
            class="open"
            v-if="liveInfo.videoSeries.length > 3"
            @click="openVideo"
            >{{ otherVideo.length < 4 ? "展开" : "收起" }}</span
          >
        </div>
        <div class="otherContent">
          <div class="inner" v-for="(item, key) in otherVideo" :key="key">
            第{{ item.seriesNumber }}集:{{ item.title }}
          </div>
        </div>
      </div>
      <div v-if="liveInfo.topicLabels.length > 0" class="tagDiv">
        标签:
        <span
          class="tagLabel"
          v-for="(item, key) in liveInfo.topicLabels"
          :key="key"
          @click="handleTopic(item)"
        >
          {{ item }}
        </span>
      </div>
      <div
        v-for="(item, key) in contentInfoList"
        :key="key"
        style="padding: 0.5rem 0.8rem; display: flex"
        @click="handleDetail(item.id)"
      >
        <div>
          <img
            :src="getImageURL(item.cover)"
            :style="{ width: '160px', borderRadius: '5px' }"
          />
        </div>
        <div
          style="
            justify-content: space-between;
            margin-left: 10px;
            display: flex;
            flex-direction: column;
          "
        >
          <div style="font-weight: bold">{{ item.title }}</div>
          <div>
            <div style="font-size: 14px; color: #999999">
              {{ item.authorName }}
            </div>
            <div style="font-size: 14px; color: #999999; padding-bottom: 5px">
              {{ item.playNumber }}观看
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="currentRecommend == 'comment'"
      :style="{
        height: `${contentHeight}rem`,
        'overflow-y': 'scroll',
        marginBottom: '3.5rem',
      }"
    >
      <div class="videoCommentList">
        <div
          class="videoCommentListDiv"
          v-for="(item, key) in commentsList"
          :key="key"
        >
          <div class="imgDiv">
            <div style="display: flex">
              <div class="block">
                <el-avatar
                  :size="40"
                  :src="getImageURL(item.avatar)"
                ></el-avatar>
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  margin: 0rem 1rem;
                  word-break: break-all;
                "
              >
                <span>{{ item.username }}</span>
                <span>{{ item.createTime | filterData }}</span>
              </div>
            </div>
          </div>
          <div style="margin-top: 5px">
            {{ item.content }}
          </div>
        </div>
      </div>
      <div class="sendVideoComment">
        <el-input
          v-model="commentsParams.content"
          :disabled="!liveInfo.commentAble"
          :placeholder="!liveInfo.commentAble ? '评论已关闭' : '请输入内容'"
        ></el-input>
        <div style="display: flex">
          <img
            src="@/assets/img/content/video/icon_chat_send.png"
            @click="sendVideoComment"
            alt="logo"
            style="width: 35px; height: 35px; margin: 0px 10px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as request from "@/utils/request";
import { getImageURL } from "@/utils/zgly-utils.js";
import turnBack from "@/components/turnBack";

import moment from "moment";
import "moment/locale/zh-cn";
export default {
  head() {
    return {
      title: `${this.liveInfo.title ? this.liveInfo.title : "视频"}-`,
      meta: [
        {
          property: 'og:title', content: this.liveInfo.title
        },
        {
          property: 'og:description', content: this.liveInfo.title
        },
        {
          property: 'og:type', content: 'website',
        },
        {
          property: 'og:image', content: this.liveInfo.smallCover
        },
        {
          property: 'og:site_name', content: '旅游TV'
        },
        {
          property: 'og:url', content: 'http://www.my100000.com:8101/video/player/' + this.liveInfo.id
        },
        {
          itemprop: 'name', content: this.liveInfo.title
        },
        {
          itemprop: 'image', content: this.liveInfo.smallCover
        },
        {
          itemprop: 'description', content: this.liveInfo.title
        },
        {
          hid: "description",
          name: "description",
          content: `${
            this.liveInfo.description
              ? this.liveInfo.description.replace(new RegExp("<.+?>", "g"), "")
              : "中国旅游影视传媒有限公司(中国旅游TV，英文简称CTTV)是在中国旅游局监督指导下，信息产业部、商务部、文化部大 力支持下成立的“互联网+旅游”专业综合平台。中国旅游TV始终坚持开拓多 渠道集群发展产业链与多环节增值的完整生态运作体系，立足于移动互联网， 秉持大盘运作的运营理念，借助资深创意策划以及媒体集团联盟优势，打造集 在线视频、网络直播、线上旅游、城市宣传、生活服务、信息集散、全景VR等 功 能于一体的新型旅游综合门户平台。"
          }`,
        },
      ],
      link: [
        {
          rel: "stylesheet",
          href: "/css/px-video.css",
        },
      ],
      script: [
        {
          src: "/js/strings.js",
        },
        {
          src: "/js/px-video.js",
        },
      ],
      innerWidth: 0,
      innerHeight: 0,
      loaded: false,
    };
  },
  components: {
    turnBack,
  },
  filters: {
    filterData(time) {
      return moment(time).fromNow();
    },
    formatReadNumber(val) {
      return val > 10000 ? `${(val / 10000).toFixed(2)}万` : val;
    },
  },
  data() {
    return {
      VUE_APP_BASE_API: process.env.VUE_APP_BASE_API,
      liveInfo: {
        videoSeries: [],
        topicLabels: [],
        previews: [],
        lookBacks: [],
      },
      commentsList: [],
      loaded: false,
      id: "",
      type: "",
      moment: moment,
      isShow: false,
      contentInfoList: [],
      authorInfo: {},
      otherVideo: [],
      openOther: false,
      commentsParams: {
        content: "",
        objectId: 0,
        offset: 0,
        toUserId: 0,
        type: ``,
      },
      contentHeight: "",
      recommendC: [
        {
          index: "video",
          value: "视频",
        },
        {
          index: "comment",
          value: "评论",
        },
      ],
      currentRecommend: "video",
      skinLayout: [
        {
          name: "bigPlayButton",
          align: "blabs",
          x: 30,
          y: 80,
        },
        {
          name: "H5Loading",
          align: "cc",
        },
        {
          name: "infoDisplay",
        },
        {
          name: "controlBar",
          align: "blabs",
          x: 0,
          y: 0,
          children: [
            { name: "playButton", align: "tl", x: 10, y: 12 },
            { name: "progress", align: "blabs", x: 0, y: 44 },
            { name: "timeDisplay", align: "tl", x: 15, y: 5 },
            {
              name: "fullScreenButton",
              align: "tr",
              x: 10,
              y: 12,
            },
            { name: "setting", align: "tr", x: 15, y: 12 },
            {
              name: "volume",
              align: "tr",
              x: 18,
              y: 10,
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.type = this.$route.query.type;
    this.innerWidth = `${document.body.clientWidth}px`;
    this.innerHeight = `${Math.floor((document.body.clientWidth * 9) / 16)}px`;
    if (this.type) {
      this.commentsParams.type = `TO_${this.type}`;
    } else {
      this.commentsParams.type = `TO_VIDEO`;
    }
    this.commentsParams.objectId = this.id;
    this.fetchData().then(() => {
      this.loaded = true;
    });
    this.selCommentById();
    this.getContentInfo(10);
    this.getAuthorInfo();
    this.contentHeight = document.documentElement.clientHeight / 16 - 15.5;
    // 检查 InitPxVideo 是否存在，避免引用错误
    if (typeof InitPxVideo !== 'undefined') {
      new InitPxVideo({
        videoId: "video_player",
        captionsOnDefault: true,
        seekInterval: 20,
        videoTitle: "PayPal Austin promo",
        debug: true,
      });
    }
    // 添加触摸事件监听，实现左右滑动切换随机ID
    this.addSwipeEvent();
  },
  created() {},
  methods: {
    async fetchData() {
      let liveInfo = {};
      let result = {};
      result = await request.getResourceVideosDetail(this.id);
      liveInfo = result.data;
      this.liveInfo = liveInfo;
      if (this.liveInfo.videoSeries.length > 3) {
        this.otherVideo = this.liveInfo.videoSeries.slice(0, 3);
      } else {
        this.otherVideo = this.liveInfo.videoSeries;
      }
    },
    // 添加滑动事件监听
    addSwipeEvent() {
      let startX = 0;
      let endX = 0;
      const container = document.getElementById('video-detail');
      
      container.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });
      
      container.addEventListener('touchend', (e) => {
        endX = e.changedTouches[0].clientX;
        this.handleSwipe(startX, endX);
      });
    },
    // 处理滑动事件
    handleSwipe(startX, endX) {
      const threshold = 50; // 滑动阈值
      if (Math.abs(startX - endX) > threshold) {
        // 生成364以内的随机数
        const randomId = Math.floor(Math.random() * 364);
        // 导航到新的URL
        this.$router.push({ path: `/video/player/${randomId}?type=VIDEO` });
      }
    },
    getImageURL(cover) {
      return getImageURL(cover);
    },
    selCommentById() {
      request
        .getCommentsByTypeById({
          type: this.commentsParams.type,
          id: this.id,
        })
        .then((res) => {
          this.commentsList = res.data.reverse();
        });
    },
    getAuthorInfo() {
      request.getUsersInfoById(this.liveInfo.authorId).then((res) => {
        this.authorInfo = {
          ...this.authorInfo,
          ...res.data,
        };
      });
      request.getUsersFansById(this.liveInfo.authorId).then((res) => {
        this.authorInfo = {
          ...this.authorInfo,
          fanNumber: res.data,
        };
      });
    },
    selVideosById() {
      request.getResourceVideosDetail(this.id).then((res) => {
        this.liveInfo = res.data;
        this.loaded = true;
      });
    },
    sendVideoComment() {
      request.createComments(this.commentsParams).then((res) => {
        this.commentsParams.content = "";
        this.selCommentById();
      });
    },
    changeCurrent(val) {
      this.currentRecommend = val;
    },
    showDescri(val) {
      this.isShow = val;
    },
    getContentInfo(val) {
      request.getResourceVideosRecently({ size: val }).then((res) => {
        let arr = res.data.filter((item) => {
          if (item.categoryId == this.liveInfo.categoryId) {
            return true;
          }
        });
        if (arr.length > 0) {
          this.contentInfoList = arr[0].videos;
        }
      });
    },
    handleDetail(id) {
      this.$router.push({ path: `/video/player/${id}?type=VIDEO` });
    },
    download() {
      this.$router.push({ path: `/download` });
    },
    downloadShare() {
      this.$notify({
        title: "下载APP",
        message: "请点击右上角，选择在浏览器打开",
      });
      return;
    },
    goToAccount() {
      this.$router.push({
        path: `/account?authorId=${this.liveInfo.authorId}`,
      });
    },
    handleTopic(val) {
      request
        .getTopics({
          topic: val,
        })
        .then((res) => {
          if (res.data) {
            this.$router.push({
              path: `/account?topic=${val}`,
            });
          } else {
            this.$router.push({
              path: `/search?content=${val}`,
            });
          }
        });
    },
    openVideo() {
      if (this.otherVideo.length > 3) {
        this.otherVideo = this.liveInfo.videoSeries.slice(0, 3);
      } else {
        this.otherVideo = this.liveInfo.videoSeries;
      }
    },
    handleRequestFullScreen() {
      this.innerWidth = `${document.body.clientWidth}px`;
      this.innerHeight = `${document.body.clientHeight}px`;
    },
    hanldCancelFullScreen() {
      this.innerWidth = `${document.body.clientWidth}px`;
      this.innerHeight = `${Math.floor(
        (document.body.clientWidth * 9) / 16
      )}px`;
    },
  },
};
</script>

<style lang="less">
#video-detail {
  // height: 100vh;
  // overflow-y: hidden;
  .vuealiplayer {
    video {
      object-fit: fill;
    }
    .prism-big-play-btn {
      margin-left: calc(50% - 32px - 30px);
    }
  }
  .title {
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
    font-size: 1rem;
    margin-bottom: 0.5rem;
    font-weight: bold;
    width: calc(100% - 30px);
    position: relative;
    .hidden {
      position: absolute;
      right: -28px;
      top: 3px;
      font-size: 20px;
    }
  }
  .otherVideo {
    .otherTitle {
      padding: 10px 20px;
      .title {
        font-size: 22px;
        font-weight: bold;
      }
      .open {
        float: right;
      }
    }
    .otherContent {
      .inner {
        width: 30%;
        overflow: hidden;
        margin: 0px 2%;
        border: 1px solid #ccc;
        padding: 4px;
      }
    }
  }
  .introduce {
    display: flex;
    justify-content: space-between;
  }
  .description {
    padding: 0px 10px 10px;
    background: #ffffff;
    border-bottom: 1px #eeeeee solid;
  }
  .fouse {
    position: absolute;
    top: 5px;
    right: 10px;
    height: 30px;
    width: 80px;
    background: rgb(0, 153, 255);
    color: #fff;
    border-radius: 5px;
    text-align: center;
    line-height: 30px;
  }
  .tagDiv {
    margin-top: 10px;
    padding: 10px;
    height: 50px;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    // ::-webkit-scrollbar:;
    .tagLabel {
      background: rgba(153, 153, 153, 1);
      color: #fff;
      border-radius: 20px;
      font-size: 14px;
      padding: 5px 10px;
      margin: 0px 5px;
    }
  }
  .videoCommentList {
    .videoCommentListDiv {
      .imgDiv {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      padding: 1rem 1rem;
      border-bottom: 1px solid #eee;
    }
  }
  .sendVideoComment {
    position: fixed;
    width: 100%;
    bottom: 0px;
    display: flex;
    padding: 0.5rem;
    background: #eee;
    height: 3.5rem;
  }
  .categoryR {
    display: flex;
    // justify-content: center;
    // position: fixed;
    // top:3rem;
    height: 2.5em;
    background: rgba(242, 242, 242, 1);
    // align-items: center;
    z-index: 9;
    width: 100%;
    div {
      width: 3rem;
      display: inline-block;
      margin: 0.5rem 0.5rem;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .categoryRActive {
      color: #379eeb;
    }
    .categoryRActive::after {
      background: #379eeb;
      content: "";
      display: block;
      margin-left: -5px;
      margin-top: 5px;
      height: 2px;
      width: 40px;
    }
  }
}
</style>

